
import * as React from 'react';
import { Button } from '@mui/material';
import { connect } from 'react-redux';
import { launchRecheckPanelExposure } from '__editor/panelsEditor/components/panels/utils/exposureRecheck';
import { canUseExposure } from '__common/components/exposure/exposureHelper';

interface Props {
  panels: panelInState[];
  selectedRoofId: number;
  buildingCode: number;
  productId: number;
}

class RecheckExposureButton extends React.Component<Props> {
  recheckExposure = () => {
    const { selectedRoofId } = this.props;
    const panelsIdsToRecheck = this.props.panels.map(panel => panel.id);
    launchRecheckPanelExposure(panelsIdsToRecheck, selectedRoofId);
  }

  render() {
    const { buildingCode, productId } = this.props;
    if (!canUseExposure(buildingCode, productId)) {
      return null;
    }

    return (
      <Button
        variant="contained"
        color="secondary"
        size="small"
        disableElevation
        onClick={this.recheckExposure}
        className="recheck-exposure-button"
        sx={{
          width: 'auto',
          minWidth: 'auto',
          alignSelf: 'flex-start',
          mt: 1,
          px: 1.5,
          py: 0.75,
          borderRadius: '2px',
          backgroundColor: '#0A3C5D',
          color: '#ffffff',
          fontFamily: 'Oswald, "PT Sans", sans-serif',
          fontSize: '0.875rem',
          fontWeight: 500,
          letterSpacing: 0,
          textTransform: 'uppercase',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: '#083049',
            boxShadow: 'none',
          },
        }}
      >
        RECHECK EXPOSURE
      </Button>
    );
  }
}

const mapStateToProps = (appState: appState) => ({
  panels: appState.panels.panels,
  buildingCode: appState.projectConfiguration.projectEnvConfig.building_code,
  selectedRoofId: appState.background.selectedRoofId,
  productId: appState.projectConfiguration.productId,
});

export default connect(mapStateToProps)(RecheckExposureButton);
